﻿/// <reference path="eXpress.ts" />
namespace eXpress {
	export function getUsedPhotoIds() {
		return eXpress.core.bulkeditor.getUsedPhotoIds();
	}
	export function getUsedPhotoNames() {
		return eXpress.core.bulkeditor.getUsedPhotoNames();
	}
}
namespace eXpress.core.bulkeditor {
	import UploadService = eXpress.services.UploadService;

	enum PrintSortBy {
		DateTaken = 0,
		DateAdded = 1,
		Name = 2
	}

	export interface IBulkEditorDependencies {
		orderService: services.OrderService;
		contentService: services.ContentService;
		accountService: services.AccountService;
	}

	export class DisplayList {
		public label: string | null;
		public quantity: number;
	}

	export interface IBulkEditorGetAllProductsResult {
		products: Product[];
		translations: eXpress.core.KeyValuePair<string>[];
		bulkSequenceShapes: string[];
	}

	export class Product {
		public readonly code: string;
		public readonly attributes: eXpress.core.KeyValuePair<string>[];
		public attributesDict: eXpress.core.Map<string>;
		public readonly options: eXpress.core.KeyValuePair<string[]>[];
		public optionsDict: eXpress.core.Map<string[]>;
	}

	export class CartItem extends core.mediastore.PhotoReference {
		public createdForced: Date;
		public dateModifiedParent: Date;
		public datePictureTaken: Date;
		public fileSize: number;
		public oldFileSystem: boolean;
		public originalFileName: string;
		public originalHeight: number;
		public originalWidth: number;
		public products: CartItemProduct[];
		public applyAllFailed: boolean;
		public photoCounter: number;
		public thumbUrl: string;
		public mediumUrl: string;
	}

	export class CartItemProduct {
		constructor(productCode: string, quantity: number) {
			this.productCode = productCode;
			this.quantity = quantity;
		}

		public productCode: string;
		public quantity: number;
		public border: string | null;
		public colorEffect: string | null;
		public paper: string | null;
		public cartItemId: string;
	}

	export class BulkEditorApp extends CustomHtmlElementsApp {
		private context: core.IAppContext;
		private services: services.Services;
		private orderService: services.OrderService;
		private contentService: services.ContentService;
		private accountService: services.AccountService;
		private pageContext: any;
		private readonly productCategoryGroupCode: string;
		private readonly parentProductCategoryCode: string;
		private fromcart: boolean;

		private defaultProductCode: string;
		private defaultTheme: string;
		private defaultQuantity: number;
		private defaultOptions: string[];

		private availableProducts: Product[];
		private availableFormats: string[];
		private availableShapes: string[];
		private availableBorders: string[];
		private availablePapers: string[];
		private availableColorEffects: string[];

		private translations: Map<string>;
		private bulkSequenceShapes: string[];

		private currentItems: CartItem[];

		private editItem: CartItem;
		private croppingIsActive: boolean;

		private contentManager: eXpress.core.ContentManager;
		private importer: eXpress.core.Importer;
		private loginManager: eXpress.core.LoginManager;

		private hadItemsInBasket: boolean;
		private formIsDirty: boolean;
		private header: JQuery;

		private $sorting: JQuery;
		private defaultSortBy: PrintSortBy;
		private defaultSortOrder: SortOrder;

		private progressPoup: ProgressPopup;

		private initialScreenWidth: number;

		constructor(deps: IBulkEditorDependencies, services: eXpress.services.Services, context: core.IAppContext, pageContext: any) {
			super();

			this.context = context;
			this.services = services;
			this.orderService = deps.orderService;
			this.contentService = deps.contentService;
			this.accountService = deps.accountService;
			this.pageContext = pageContext;

			this.$sorting = $(".multiselect.multiselect-sorting");
			const enforcedSort = eXpress.utils.getQueryStringParameter("sort", undefined, false);
			const enforcedOrder = eXpress.utils.getQueryStringParameter("order", undefined, false);
			if (enforcedSort) {
				this.defaultSortBy = PrintSortBy[enforcedSort];
			} else {
				this.defaultSortBy = PrintSortBy.DateAdded;
			}
			if (enforcedOrder) {
				this.defaultSortOrder = SortOrder[enforcedOrder];
			} else {
				this.defaultSortOrder = SortOrder.Ascending;
			}
			this.setSelectedSortingInUI(this.defaultSortBy, this.defaultSortOrder);

			const oldHeader = $('.editor-header');
			this.header = oldHeader.length > 0 ? oldHeader : $('.o-small-header');

			// loads initial filters
			this.productCategoryGroupCode = eXpress.utils.getQueryStringParameter("pcg", undefined, true).toLowerCase();

			this.parentProductCategoryCode = this.productCategoryGroupCode;
			if (this.parentProductCategoryCode.indexOf(".") > -1)
				this.parentProductCategoryCode = this.parentProductCategoryCode.substr(0, this.parentProductCategoryCode.indexOf("."));

			this.defaultProductCode = eXpress.utils.getQueryStringParameter("pvc", undefined, true).toLowerCase();
			this.defaultTheme = eXpress.utils.getQueryStringParameter("theme", undefined, false);
			if (this.defaultTheme) this.defaultTheme = this.defaultTheme.toLowerCase();

			this.fromcart = !!eXpress.utils.getQueryStringParameter("fromcart") || false;
			if (eXpress.utils.getQueryStringParameter("options"))
				this.defaultOptions = eXpress.utils.getQueryStringParameter("options").toLowerCase().split(',');
			this.defaultQuantity = parseInt(eXpress.utils.getQueryStringParameter("quantity") || "1", 10);

			this.contentManager = new ContentManager(this.contentService, GetCookie("slbls").toLowerCase() === "true");

			const importerDependencies = {
				productCategory: this.parentProductCategoryCode,
				contentManager: this.contentManager,
				storageService: this.services.storageService,
				processSelectedPhotosAsync: this.processSelectedPhotosAsync.bind(this),
				uploadService: this.services.uploadService
			} as eXpress.core.IImporterDependencies;
			this.importer = new Importer(importerDependencies);

			this.loginManager = new LoginManager(this.accountService);
		}

		public getUsedPhotoIds(): string[] {
			return this.currentItems.map(x => x.photoId);
		}

		public getUsedPhotoNames(): string[] {
			return this.currentItems.map(x => x.originalFileName);
		}

		public start(): void {
			// This page requires authentication ... it can be long gone when we load the javascript (clear cookies etc) -> check on it
			const isAuthenticated = utils.isAuthenticationCheck(GetCookie("accid"));
			if (!isAuthenticated) {
				document.location.reload();
				return;
			}

			this.initProducts();
			this.addHandlers();
			this.clear();
			this.registerNavigateAwayQuestion();

			this.loginManager.start(this.context.accountType);
		}

		private clear(): void {
			$('.filter-sorting').removeClass('hidden');
			$('.accept-filter').remove();
		}

		private redirectTo404(): JQueryPromise<unknown> {
			window.location.href = `${window.location.origin}/404`;
			setTimeout(() => {
				return;
			}, 1000);
			return $.Deferred().resolve();
		}

		private initProducts(): void {
			this.currentItems = [];

			core.showLoadingDialogAsync(this.contentService.bulkEditorGetAllProductsAsync(core.context.pointOfSaleId,
				core.context.languageCode,
				this.productCategoryGroupCode,
				this.defaultProductCode).then((res) => {

					if (!res) {
						core.showLoadingDialogAsync(this.redirectTo404());
						return;
					}

					this.translations = utils.convertKeyValuePairToMap(res.translations);
					this.bulkSequenceShapes = res.bulkSequenceShapes;
					this.availableProducts = res.products;
					this.availableProducts.forEach((availableProduct) => {
						availableProduct.attributesDict = utils.convertKeyValuePairToMap(availableProduct.attributes);
						availableProduct.optionsDict = utils.convertKeyValuePairToMap(availableProduct.options);
					});
					this.initAvailableLists();
					this.initApplyAll();
					const initExistingCartItemsPromise = this.initExistingCartItemsAsync();
					const initExistingMyPhotoItemsPromise = this.initExistingMyPhotoItemsAsync();

					return $.when(initExistingCartItemsPromise, initExistingMyPhotoItemsPromise).then(async () => {
						if (this.currentItems.length === 0)
							await this.openAddDialogAsync();
					});

				}));
		}

		private initApplyAll(): void {
			const $container = $('.multiselect-wrapper').detach();
			const $template = $container.find('.multiselect').detach();

			this.initApplyAllMultiselect($template, $container, this.availableColorEffects, 'coloreffect');
			this.initApplyAllMultiselect($template, $container, this.availableBorders, 'border');
			this.initApplyAllMultiselect($template, $container, this.availablePapers, 'paper');
			this.initApplyAllMultiselect($template, $container, this.availableShapes, 'shape');
			this.initApplyAllMultiselect($template, $container, this.availableFormats, 'format');
			this.initApplyAllMultiselect($template, $container, null, 'quantity');

			$('.filter-choice-multiselect').append($container);
		}

		private initApplyAllMultiselect($template: JQuery, $container: JQuery, list: string[] | null, code: string): void {
			if (list && list.length <= 1)
				return;

			const $new = $template.clone();
			$new.addClass(code);
			$new.attr('data-code', code);

			const $subContainer = $new.find('.selectbox-choices').detach();
			const $subTemplate = $subContainer.find('label');
			$subContainer.empty();
			let maxLength = 100;
			if (list)
				maxLength = list.length;
			for (let i = 0; i < maxLength; i++) {
				const $subNew = $subTemplate.clone();
				let label = (i + 1).toString();
				if (list) {
					label = this.translations[code + '.' + list[i]];
					if (!label)
						label = code + list[i];
					$subNew.attr('data-code', list[i]);
				} else {
					$subNew.attr('data-code', label);
				}
				$subNew.html(label);
				$subContainer.append($subNew);
			}

			$new.append($subContainer);
			$container.prepend($new);
		}

		// Returns true if all items in the form are excatly the same
		private initApplyAllTitle(): boolean {
			/* This will set the visual cue for the apply all dropdown
				The rule: For one dropdown, if ALL items in the form are the same, set the selecte value
				If not, set the label.
			*/
			let labelQuantity: string | null = null;
			let labelFormat: string | null = null;
			let labelShape: string | null = null;
			let labelPaper: string | null = null;
			let labelBorder: string | null = null;
			let labelColorEffect: string | null = null;
			let shouldInit = true;
			let allItemsAreTheSame = true;
			if (this.currentItems && this.currentItems.length > 0) {
				this.currentItems.forEach(item => {
					item.products.forEach(product => {
						const availableProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === product.productCode);
						if (shouldInit) {
							shouldInit = false;

							labelQuantity = (product.quantity || 1).toString();

							labelFormat = this.translations['format.' + availableProduct.attributesDict['format']];
							labelShape = this.translations['shape.' + availableProduct.attributesDict['shape']];
							labelPaper = this.translations['paper.' + (product.paper ? product.paper : 'default')];
							labelBorder = this.translations['border.' + (product.border ? product.border : 'default')];
							labelColorEffect = this.translations['coloreffect.' + (product.colorEffect ? product.colorEffect : 'default')];
						} else {
							// Check the difference between the current label and the one we have
							if (labelQuantity === null || labelQuantity !== product.quantity.toString()) {
								// Comment Stef remark labelQuantity = this.pageContext.labelQuantity;
								labelQuantity = '&nbsp;';
								allItemsAreTheSame = false;
							}
							if (labelFormat !== this.translations['format.' + availableProduct.attributesDict['format']]) {
								// Comment Stef remark labelFormat = this.pageContext.labelFormat;
								labelFormat = '&nbsp;';
								allItemsAreTheSame = false;
							}
							if (labelShape !== this.translations['shape.' + availableProduct.attributesDict['shape']]) {
								// Comment Stef remark labelShape = this.pageContext.labelShape;
								labelShape = '&nbsp;';
								allItemsAreTheSame = false;
							}
							if (labelPaper !== this.translations['paper.' + (product.paper ? product.paper : 'default')]) {
								// Comment Stef remark labelPaper = this.pageContext.labelPaper;
								labelPaper = '&nbsp;';
								allItemsAreTheSame = false;
							}
							if (labelBorder !== this.translations['border.' + (product.border ? product.border : 'default')]) {
								// Comment Stef remark labelBorder = this.pageContext.labelBorder;
								labelBorder = '&nbsp;';
								allItemsAreTheSame = false;
							}
							if (labelColorEffect !== this.translations['coloreffect.' + (product.colorEffect ? product.colorEffect : 'default')]) {
								// Comment Stef remark labelColorEffect = this.pageContext.labelColorEffect;
								labelColorEffect = '&nbsp;';
								allItemsAreTheSame = false;
							}
						}
					});
				});
			} else {
				labelQuantity = this.pageContext.labelQuantity;
				labelFormat = this.pageContext.labelFormat;
				labelShape = this.pageContext.labelShape;
				labelPaper = this.pageContext.labelPaper;
				labelBorder = this.pageContext.labelBorder;
				labelColorEffect = this.pageContext.labelColorEffect;
			}

			$('.filter-container .multiselect.quantity .selectBox span.label').html(labelQuantity || "");
			$('.filter-container .multiselect.format .selectBox span.label').html(labelFormat || "");
			$('.filter-container .multiselect.shape .selectBox span.label').html(labelShape || "");
			$('.filter-container .multiselect.paper .selectBox span.label').html(labelPaper || "");
			$('.filter-container .multiselect.border .selectBox span.label').html(labelBorder || "");
			$('.filter-container .multiselect.coloreffect .selectBox span.label').html(labelColorEffect || "");

			// Set the info message  info-all-photos
			let infoLabel = '';
			if (!allItemsAreTheSame)
				infoLabel += this.pageContext.labelMultipleItems;
			infoLabel += this.pageContext.labelApplyAll.replace('{0}', this.currentItems.length);

			$('.info-all-photos').html(infoLabel);

			return allItemsAreTheSame;
		}

		private initExistingMyPhotoItemsAsync(): JQueryPromise<void> {
			// We either have photoids and one folderId or no photoIds and one or more folderids
			const strFolderIds = this.pageContext.folderids;
			const strPhotoIds = this.pageContext.photoids;
			const useDeselected = this.pageContext.useDeselected;
			const isSelectAllActive = this.pageContext.isSelectAllActive;
			const limit = this.pageContext.limit;

			if (strPhotoIds) {
				return this.addNewItemsByPhotoIdsAsync(strFolderIds.split(",")[0], strPhotoIds.split(","), useDeselected, isSelectAllActive);
			}
			else if (strFolderIds) {
				return this.addNewItemsByFolderIdsAsync(strFolderIds.split(","), useDeselected, limit);
			}
			return $.Deferred<void>().resolve().promise();
		}

		private initExistingCartItemsAsync(): JQueryPromise<void> {
			if ((!pageContext.cartId || pageContext.cartId === eXpress.core.emptyGuid) && !this.pageContext.defId) {
				this.displayTotals();
				this.initApplyAllTitle();
				return $.Deferred<void>().resolve().promise();
			}

			window.ShowLoadingDialog();
			return this.orderService.bulkEditorGetCartItemsAsync(core.context.pointOfSaleId, GetCookie("accid"), pageContext.cartId, this.defaultProductCode, this.pageContext.defId)
				.then(res => {
					res.forEach((item) => {
						this.currentItems.push(item);
					});

					if (this.currentItems.length > 0)
						this.hadItemsInBasket = true;
					this.sortAndDisplayItems(this.defaultSortBy, this.defaultSortOrder);
					this.initApplyAllTitle();
					this.initBasketButton();
					window.HideLoadingDialog();
				});
		}

		private initBasketButton() {
			if (this.hadItemsInBasket)
				$('.content-container .add-prints .button span.label').html(this.pageContext.labelUpdateBasket);
			$('.editor-header .add-prints span.label').html(this.pageContext.labelUpdateBasket);
		}

		private openAddDialogAsync = async () => {
			this.importer.openAsync();
		};

		private processSelectedPhotosAsync = async (data: IPhotoImport | null): Promise<void> => {
			const photos = await this.assureSmartphotoPhotosAsync(data);
			if (photos.length)
				this.addNewItems(photos);
		};

		private assureSmartphotoPhotosAsync = async (data: IPhotoImport | null): Promise<Photo[]> => {
			if (!data)
				return $.Deferred<Photo[]>().resolve([]).promise();

			const photos = data.selection;
			if (!photos)
				return $.Deferred<Photo[]>().resolve([]).promise();

			// photos already eXpress? => no need to convert, just return them
			if (data.storeType == StoreType.eXpress)
				return $.Deferred<Photo[]>().resolve(photos as Photo[]).promise();


			return core.showLoadingDialogAsync(ProgressPopup.createDialogAsync())
				.then(async $popup => {
					this.progressPoup = new ProgressPopup($popup);

					await this.progressPoup.setProgressDialogContentAsync(this.contentManager, "Label.UploadProgressDialog.Counter", photos.length);
					const token = await eXpress.services.getToken();
					const downloadedPhotos = await this.getDownloader(token, this.progressPoup)
						.addToQueueAsync(photos as partners.PartnerPhoto[]);

					return [...downloadedPhotos];
				});
		};

		private getDownloader = (token: string, popup: ProgressPopup): Downloader => {
			return new Downloader(new eXpress.services.DownloadService(token, this.context.ecomApiUrl, this.parentProductCategoryCode), "prints", popup);
		};

		private addNewItems(photos: ISmartphotoPhoto[]): void {
			const availableProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === this.defaultProductCode);
			this.formIsDirty = true;
			for (let i = 0; i < photos.length; i++) {
				const photo = photos[i];
				const cartItem = new CartItem();
				cartItem.id = photo.fileId;
				cartItem.photoCounter = this.getFreePhotoCounter(cartItem.id);
				cartItem.photoId = photo.fileId;
				cartItem.originalWidth = photo.width;
				cartItem.originalHeight = photo.height;
				cartItem.datePictureTaken = photo.dateTaken ? photo.dateTaken : new Date();
				cartItem.createdForced = new Date();
				cartItem.fileSize = photo.fileSize;
				cartItem.originalFileName = photo.originalFilename;
				cartItem.dateModifiedParent = new Date();
				cartItem.thumbUrl = photo.thumbUrl;
				cartItem.mediumUrl = photo.mediumUrl;

				cartItem.manipulations = new mediastore.Manipulations();
				cartItem.manipulations.rotate90 = photo.rotate90;
				cartItem.manipulations.colorEffect = null;
				cartItem.manipulations.height = 0;
				cartItem.manipulations.width = 0;
				cartItem.manipulations.top = 0;
				cartItem.manipulations.left = 0;

				// Create 1 product for the newly added item
				cartItem.products = [];

				const product = new CartItemProduct(this.defaultProductCode, this.defaultQuantity);
				cartItem.products.push(product);

				// We add the default options
				if (this.defaultOptions && this.defaultOptions.length > 0)
					this.addNewItemAddAvailabeOptions(availableProduct, cartItem, product, this.defaultOptions);

				this.currentItems.push(cartItem);

				this.changeManipulationsForOneItem(cartItem, 'shape', availableProduct.attributesDict['shape']);
			}

			this.sortAndDisplayItems(this.defaultSortBy, this.defaultSortOrder);
			const allitemsAreTheSame = this.initApplyAllTitle();
			this.toggleApplyAll(true);

			this.showDialogAfterAddedItems(photos.length, availableProduct, allitemsAreTheSame);
		}

		private addNewItemAddAvailabeOptions(availableProduct: Product, item: CartItem, product: CartItemProduct, optionList: string[]) {
			const availablePaper = this.getAvailableOption(availableProduct, 'paper', optionList);
			if (availablePaper)
				product.paper = availablePaper;
			const availableBorder = this.getAvailableOption(availableProduct, 'border', optionList);
			if (availableBorder)
				product.border = availableBorder;
			const availableColorEffect = this.getAvailableOption(availableProduct, 'coloreffect', optionList);
			if (availableColorEffect) {
				product.colorEffect = availableColorEffect;
				// Special case, thumb needs to change to bw or speia !
				this.changeManipulationsForOneItem(item, 'coloreffect', availableColorEffect);
			}
		}

		private getAvailableOption(availableProduct: Product, category: string, optionList: string[]) {
			const available = availableProduct.optionsDict[category];
			let result: string | null = null;
			if (available && available.length > 0) {
				available.forEach(a => {
					if (optionList.indexOf(a) > -1)
						result = a;
				});
			}
			return result;
		}

		private showDialogAfterAddedItems(count: number, product: Product, allitemsAreTheSame: boolean) {
			if (!product.attributesDict['showinbulk'])
				return;

			const labelFormat = this.translations['format.' + product.attributesDict['format']];
			const labelShape = this.translations['shape.' + product.attributesDict['shape']];

			// Set for options by default but not yet implemented
			let keyPaper = 'paper.default';
			let keyBorder = 'border.default';
			let keyColoreffect = 'coloreffect.default';
			if (this.defaultOptions && this.defaultOptions.length > 0) {
				const tempPaper = this.getAvailableOption(product, 'paper', this.defaultOptions);
				if (tempPaper)
					keyPaper = 'paper.' + tempPaper;
				const tempBorder = this.getAvailableOption(product, 'border', this.defaultOptions);
				if (tempBorder)
					keyBorder = 'border.' + tempBorder;
				const tempColoreffect = this.getAvailableOption(product, 'coloreffect', this.defaultOptions);
				if (tempColoreffect)
					keyColoreffect = 'coloreffect.' + tempColoreffect;
			}

			const labelPaper = this.translations[keyPaper];
			const labelBorder = this.translations[keyBorder];
			const labelColorEffect = this.translations[keyColoreffect];

			let labelWarningAfterAddedItems = '';
			if (!allitemsAreTheSame)
				labelWarningAfterAddedItems = this.pageContext.labelWarningAfterAddedItems;

			window.ShowContentDialog({
				action: 'BulkEditorInfo',
				label: 'ResponsivePrintForm.Import.UploadedPhotos.Info',
				dialogId: 'infoAfterAdd',
				okContentKey: 'Label.OkButtonText',
				closeOnWrapper: true,
				forceRefresh: true,
				data: {
					'labelFormat': encodeURIComponent(labelFormat),
					'labelShape': encodeURIComponent(labelShape),
					'labelPaper': encodeURIComponent(labelPaper),
					'labelBorder': encodeURIComponent(labelBorder),
					'labelColorEffect': encodeURIComponent(labelColorEffect),
					'count': count,
					'labelWarningAfterAddedItems': encodeURIComponent(labelWarningAfterAddedItems)
				}
			});
		}

		private addNewItemsByPhotoIdsAsync(folderId: string, photoIds: string[], useDeselected: boolean, isSelectAllActive: boolean): JQueryPromise<void> {
			if (photoIds.length > 0) {
				this.formIsDirty = true;
				return core.showLoadingDialogAsync(this.services.storageService.getPhotosAsync(core.context.pointOfSaleId, GetCookie("accid"), folderId, photoIds, useDeselected, isSelectAllActive).then((photos) => {
					this.addNewItems(photos);
				}));
			}

			return $.Deferred<void>().resolve().promise();
		}

		private addNewItemsByFolderIdsAsync(folderIds: string[], useDeselected: boolean, limit: number): JQueryPromise<void> {
			if (folderIds.length > 0) {
				this.formIsDirty = true;
				return core.showLoadingDialogAsync(this.services.storageService.getPhotosByFoldersAsync(core.context.pointOfSaleId, GetCookie("accid"), folderIds, useDeselected, limit).then((photos) => {
					this.addNewItems(photos);
				}));
			}

			return $.Deferred<void>().resolve().promise();
		}

		private displayItems(): void {
			const $container = $('.prints-editor');
			const printItemContainerForMeasurement = $container.find('.item.print.portrait.add-photo');
			const printItemContainerWidth = printItemContainerForMeasurement.find('div.item-container').outerWidth();
			const printItemMaxSize = parseInt(printItemContainerForMeasurement.find('img').css("maxHeight"), 10);

			$container.detach();
			const $template = $container.find('.item-template');

			for (let i = 0; i < this.currentItems.length; i++) {
				const currentItem = this.currentItems[i];
				let $new = $template.clone().show();
				$new = this.fillOneItem($new, currentItem, printItemContainerWidth, printItemMaxSize);
				$container.append($new);
			}
			$('.content .content-container .top-content-container').after($container);

			this.pageContext.lazyload.update(); // We have changed URLs of images -> reset the lazyloader to reload those
			this.displayTotals();
		}

		private displayTotals(): void {
			const totalOrdered = this.getTotalQuantity();

			let label = this.pageContext.labelPhotoCount.toString();
			$('.photos-amount').html(label.replace('{0}', this.currentItems.length.toString()));

			if (totalOrdered === 1)
				label = this.pageContext.labelPrintsCountOne.toString();
			else
				label = this.pageContext.labelPrintsCount.toString();
			$('.prints-amount .label-total strong').html(utils.formatString(label, totalOrdered.toString()));

			if (this.currentItems.length > 0) {
				this.orderService.GetBulkPriceAsync(this.context.pointOfSaleId,
					this.context.languageCode,
					this.currentItems,
					this.pageContext.promoCode).then((res: any) => {
						const $tooltip = $('.prints-amount .top-info-container');
						this.fillTotalTooltip($tooltip, res.GetBulkPriceResult);
					});
			} else {
				this.header.find('.technical-price').show().find('.technical-amount').html("-");
			}
		}

		private fillOneItem($html: JQuery, item: CartItem, printItemContainerWidth = 0, printItemMaxSize = 0): JQuery {
			// Specify classes & attributes for the top container
			$html.attr('id', `bulkItem_${item.photoId}_${item.photoCounter}`);
			$html.attr('fileId', item.photoId);
			$html.attr('photoCounter', item.photoCounter);
			$html.removeClass('item-template').addClass('print');

			this.refreshOneItem($html, item, printItemContainerWidth, printItemMaxSize);

			return $html;
		}

		private refreshOneItem($html: JQuery, item: CartItem, printItemContainerWidth = 0, printItemMaxSize = 0, resetImages = true): void {
			// Refresh the image
			$html.removeClass("portrait landscape square");
			$html.addClass(core.mediastore.itemGetOrientation(item));

			$html.toggleClass('warning', !this.checkMinResolution(item));

			const $imgClient = $html.find('.img-container img.client-manipulation');
			const $img = $html.find('.img-container img.server-rendering');
			if (this.getWhiteBorderType(item) !== WhiteBorderType.None) {
				if (resetImages) {
					$img.attr('src', '');
					$img.attr('data-src', bulkeditor.fillOneItemUrl(item, this.context.ecomApiUrl, this.getWhiteBorderType(item), false, false));
					if (window.LazyLoad) window.LazyLoad.resetStatus($img[0]);
					// also remove classes loaded and enterd sins the library won't do it
					$img[0].classList.remove('entered');
					$img[0].classList.remove('loaded');
				}

				$imgClient.parent().css('display', 'none');
				$img.css('display', '');
			} else {
				this.fillOneItemRawUrl($imgClient, item, printItemContainerWidth, printItemMaxSize, resetImages);
				$img.css('display', 'none');
				$imgClient.parent().css('display', '');
			}

			// Fill the amount data
			const $domAmount = $html.find('.info-wrapper .amount');
			$domAmount.html(this.getQuantityForOneItem(item).toString());

			// Fill the format data
			if (item.products.length > 1)
				$html.find('.format-in-tile').html(this.pageContext.labelMultipleFormats);
			else {
				const availableProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === item.products[0].productCode);
				const labelFormat = this.translations['format.' + availableProduct.attributesDict['format']];
				$html.find('.format-in-tile').html(labelFormat);
			}

		}

		private checkMinResolution(item: CartItem): boolean {
			let longestSide = item.manipulations.width > item.manipulations.height ? item.manipulations.width : item.manipulations.height;
			if (longestSide <= 0)
				longestSide = item.originalWidth > item.originalHeight ? item.originalWidth : item.originalHeight;

			let qualityOk = true;
			item.products.forEach(product => {
				const actualProduct = eXpress.utils.findFirst(this.availableProducts, p => p.code === product.productCode);
				if (actualProduct)
					if (parseInt((actualProduct.attributesDict["minimumwidth"] || "0"), 10) > longestSide)
						qualityOk = false;
			});
			return qualityOk;
		}

		private displayOneItem($previousItem: JQuery, item: CartItem): void {
			const $container = $('.prints-editor');
			const $template = $container.find('.item-template');
			let $new = $template.clone().show();
			$new = this.fillOneItem($new, item);
			$new.insertAfter($previousItem);
		}

		private getWhiteBorderType(item: CartItem): WhiteBorderType {
			const firstProduct = eXpress.utils.findFirst(this.availableProducts, p => p.code === item.products[0].productCode);
			if (!firstProduct)
				return WhiteBorderType.None;

			if (item.products[0].border === 'printsborderwhite3mm')
				return WhiteBorderType.Normal3mm;
			else if (firstProduct.attributesDict['printsborder'] && firstProduct.attributesDict['printsborder'].toLowerCase() === 'retro')
				return WhiteBorderType.Retro;
			else
				return WhiteBorderType.None;
		}

		private fillOneItemRawUrl($img: JQuery, item: CartItem, printItemContainerWidth = 0, imageLongest = 0, resetImages = true) {
			// Crop in CSS first, then rotation (like the manipulations on server)
			let scaleRatio = 0;

			const itemManipulationsWidth = item.manipulations.width > 0 ? item.manipulations.width : item.originalWidth;
			const itemManipulationsHeight = item.manipulations.height > 0 ? item.manipulations.height : item.originalHeight;

			const imageRatio = itemManipulationsWidth / itemManipulationsHeight;
			let imageMediumLongest = 0;
			let imageWidth = 0;
			let imageHeight = 0;
			const $clipImageDiv = $img.parent("div.clip-image");

			if (printItemContainerWidth === 0 || imageLongest === 0) {
				const $container = $('.prints-editor');
				const printItemContainerForMeasurement = $container.find('.item.print.portrait.add-photo');
				printItemContainerWidth = printItemContainerForMeasurement.find('div.item-container').outerWidth() || 0;
				imageLongest = parseInt(printItemContainerForMeasurement.find('img').css("maxHeight"), 10);
			}

			// set imageMediumLongest (= dimension of longest side of medium image (= image from server to clip on)
			if (imageRatio > 1)
				imageMediumLongest = itemManipulationsWidth;
			else
				imageMediumLongest = itemManipulationsHeight;

			// set corresponding scaleRatio
			scaleRatio = imageLongest / imageMediumLongest;

			// calculate clipping on medium image
			const clipTop = item.manipulations.top * scaleRatio;
			const clipRight = (item.originalWidth - item.manipulations.left - itemManipulationsWidth) * scaleRatio;
			const clipBottom = (item.originalHeight - item.manipulations.top - itemManipulationsHeight) * scaleRatio;
			const clipLeft = item.manipulations.left * scaleRatio;

			// dimensions of imageDiv = dimensions of manipulated image on screen
			if (imageRatio > 1) {
				imageWidth = imageLongest;
				imageHeight = imageLongest / imageRatio;
			} else {
				imageWidth = imageLongest * imageRatio;
				imageHeight = imageLongest;
			}

			// set clipping css
			// Set width and height on clipping div for clipping Bottom and Right
			$clipImageDiv.css('width', Math.round(imageWidth).toFixed(0));
			$clipImageDiv.css('height', Math.round(imageHeight).toFixed(0));
			$clipImageDiv.css('overflow', 'hidden');

			// Set Margin on Image for clipping Top and Left. Syntax Margin(T,R,B,L)
			$img.css('width', Math.round(imageWidth + clipLeft + clipRight).toFixed(0));
			$img.css('height', Math.round(imageHeight + clipBottom + clipTop).toFixed(0));
			$img.css('margin', "-" + Math.round(clipTop).toFixed(0) + "px 0px 0px -" + Math.round(clipLeft).toFixed(0) + "px");

			// Place image on the correct place ...
			const marginToCenter = (printItemContainerWidth - imageWidth) / 2 - 20; // 20px padding on img-wrapper
			$clipImageDiv.css('margin', "0px 0px 0px " + Math.round(marginToCenter).toFixed(0) + "px");

			// Rotate
			$clipImageDiv.css('transform', 'rotate(' + item.manipulations.rotate90 + 'deg)');
			$clipImageDiv.css('-webkit-transform', 'rotate(' + item.manipulations.rotate90 + 'deg)');

			// ColorEffect needs be be rendered on server ... once
			if ((item.manipulations.colorEffect && item.manipulations.colorEffect.toLowerCase() !== 'none')
				|| item.mediumUrl.toLowerCase().indexOf("photohandler.ashx") > -1
				|| item.mediumUrl.toLowerCase().indexOf("/transforms?") > -1) {
				item.mediumUrl = fillOneItemUrl(item, this.context.ecomApiUrl, this.getWhiteBorderType(item));
			}

			if (resetImages) {
				$img.attr('src', '');
				$img.attr('data-src', item.mediumUrl);
				if (window.LazyLoad) window.LazyLoad.resetStatus($img[0]);
				$img[0].classList.remove('entered');
				$img[0].classList.remove('loaded');
			}
		}

		private fillTotalTooltip($tooltip: JQuery, $result: any) {
			const $list = $('.prints-amount .price-detail-list');
			const $price = this.header.find('.technical-price').show().find('.technical-amount');

			// Update the actual price
			$price.html(utils.displayPrice($result.Price.Amount, true, false, this.pageContext));

			// Update the detailed table below the price
			const $container = $list.find('.price-detail-list-container').detach();
			const $template = $container.find('.price-detail-list-template').first().removeClass('product');
			$container.empty();

			for (let i = 0; i < $result.PriceItems.length; i++) {
				const $new = $template.clone();
				$new.find('.price-detail-description').html($result.PriceItems[i].Description);
				$new.find('.price-detail-calculation').html($result.PriceItems[i].CalculationDescription);
				$new.find('.price-detail-result').html($result.PriceItems[i].ItemTotal);
				if ($result.PriceItems[i].Type)
					$new.addClass($result.PriceItems[i].Type);
				$container.append($new);
			}

			$list.append($container);
		}

		//				this.initApplyAllMultiselect($template, $container, this.availableColorEffects, 'coloreffect');
		//this.initApplyAllMultiselect($template, $container, this.availableBorders, 'border');
		//this.initApplyAllMultiselect($template, $container, this.availablePapers, 'paper');
		//this.initApplyAllMultiselect($template, $container, this.availableShapes, 'shape');
		//this.initApplyAllMultiselect($template, $container, this.availableFormats, 'format');

		private fillOneItemTooltip($domItem: JQuery, $tooltip: JQuery) {
			const photoId = $domItem.attr('fileid') || "";
			const photoCounter = +($domItem.attr('photocounter') || 0);
			const item = this.getItemByPhotoIdAndCounter(photoId, photoCounter);

			const firstProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === item.products[0].productCode);

			// Shape is part of the product, so just display it
			if (this.availableShapes.length > 1)
				$tooltip.find('.tooltip-shape label').html(this.translations['shape.' + firstProduct.attributesDict['shape']]);
			else
				$tooltip.find('table.shape').hide();

			// Paper, border and coloreffect are options that can be on or off
			const paper = item.products[0].paper ? item.products[0].paper : 'default';
			const border = item.products[0].border ? item.products[0].border : 'default';
			const colloreffect = item.products[0].colorEffect ? item.products[0].colorEffect : 'default';

			if (this.availablePapers.length > 1)
				$tooltip.find('.tooltip-paper label').html(this.translations['paper.' + paper]);
			else
				$tooltip.find('table.paper').hide();
			if (this.availableBorders.length > 1)
				$tooltip.find('.tooltip-border label').html(this.translations['border.' + border]);
			else
				$tooltip.find('table.border').hide();
			if (this.availableColorEffects.length > 1)
				$tooltip.find('.tooltip-coloreffect label').html(this.translations['coloreffect.' + colloreffect]);
			else
				$tooltip.find('table.coloreffect').hide();

			// Format is based on the product, but multiple are possible
			const $template = $tooltip.find('.tooltip-format-template');
			const $container = $template.parent();
			const $parent = $container.parent();
			$container.detach();
			$container.find('.tooltip-format').not('.tooltip-format-template').remove();
			for (let i = 0; i < item.products.length; i++) {
				const product = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === item.products[i].productCode);
				const $new = $template.clone().removeClass('tooltip-format-template').show();
				$new.find('label').html(item.products[i].quantity + ' x ' + this.translations['format.' + product.attributesDict['format']]);
				$container.append($new);
			}
			$parent.append($container);
		}

		private deleteItem($domItem: JQuery): void {
			this.formIsDirty = true;

			const photoId = $domItem.attr('fileid');
			const photoCounter = $domItem.attr('photocounter');

			// Remove from the list of items
			eXpress.utils.removeItem(this.currentItems, i => i.photoId === photoId && i.photoCounter.toString() === photoCounter);

			// Remove from the DOM
			$domItem.remove();

			this.displayTotals();
			this.initApplyAllTitle();
		}

		private getItemsByPhotoId(photoId: string): CartItem[] {
			return this.currentItems.filter(item => item.photoId === photoId);
		}

		private getItemByPhotoIdAndCounter(photoId: string, photoCounter: number): CartItem {
			const result = this.currentItems.filter(function (currentItem) {
				if (currentItem.photoId === photoId && currentItem.photoCounter === photoCounter)
					return true;
			});

			if (result.length === 0)
				throw new Error("No cart item found by photo id and counter");

			return result[0];
		}

		private getProductByAttributes(format: string | null, shape: string | null, border: string | null, colorEffect: string | null, paper: string | null): Product | null {
			for (let i = 0; i < this.availableProducts.length; i++) {
				const product = this.availableProducts[i];
				const aFormatKVP = eXpress.utils.findFirst(product.attributes, lv => lv.Key === 'format');
				const aFormat = aFormatKVP ? aFormatKVP.Value : null;
				if (format !== aFormat)
					continue;
				const aShapeKVP = eXpress.utils.findFirst(product.attributes, lv => lv.Key === 'shape');
				const aShape = aShapeKVP ? aShapeKVP.Value : null;
				if (shape !== aShape)
					continue;
				if (border && border !== 'default') {
					const aBorder = this.getListValueArrayByCode(product.options, 'border');
					if (aBorder === null || aBorder.indexOf(border) < 0)
						continue;
				}
				if (colorEffect && colorEffect !== 'default') {
					const aColorEffect = this.getListValueArrayByCode(product.options, 'coloreffect');
					if (aColorEffect === null || aColorEffect.indexOf(colorEffect) < 0)
						continue;
				}
				if (paper && paper !== 'default') {
					const aPaper = this.getListValueArrayByCode(product.options, 'paper');
					if (aPaper === null || aPaper.indexOf(paper) < 0)
						continue;
				}
				return product;
			}

			return null;
		}

		private getListValueArrayByCode(list: eXpress.core.KeyValuePair<string[]>[], code: string): string[] | null {
			if (!list)
				return null;

			for (let i = 0; i < list.length; i++) {
				if (list[i].Key === code)
					return list[i].Value;
			}

			return null;
		}

		private getFreePhotoCounter(photoId: string): number {
			const items = this.getItemsByPhotoId(photoId);
			let counter = 0;
			items.forEach((item) => {
				if (item.photoCounter > counter)
					counter = item.photoCounter;
			});
			counter++;
			return counter;
		}

		private copyItem($domItem: JQuery): void {
			this.formIsDirty = true;

			const photoId = $domItem.attr('fileid') || "";
			const photoCounter = $domItem.attr('photocounter');

			// Insert into the list of existing items
			const existing = this.currentItems.filter(currentItem => currentItem.photoId === photoId && currentItem.photoCounter.toString() === photoCounter);

			if (existing.length > 0) {
				const itemToAdd = utils.clone(existing[0]);
				itemToAdd.photoCounter = this.getFreePhotoCounter(photoId);
				itemToAdd.id = eXpress.core.emptyGuid;
				this.currentItems.push(itemToAdd);

				// Insert into the DOM
				this.displayOneItem($domItem, itemToAdd);

				this.pageContext.lazyload.update();
			}

			this.displayTotals();
		}

		private deleteAll() {
			window.ShowContentDialog({
				label: 'ResponsivePrintForm.DeleteAllPhotos',
				okContentKey: 'Label.DeleteButtonText',
				cancelContentKey: 'Label.KeepButtonText',
				cssClass: 'rspdialog',
				dialogId: 'deleteAll',
				okFunction: () => {
					this.formIsDirty = true;

					// in the object
					this.currentItems = [];

					// in the DOM
					$('.prints-editor .item').not('.item-template').not('.add-photo').remove();

					// Reset the totals
					this.displayTotals();

					this.initApplyAllTitle();
				}
			});
		}

		private applyAll(index: string, value: string) {
			// ApplyAll has 2 runs: 1 test if I can apply to all, 2 actually apply to all

			let errorCount = 0;
			const errorList: DisplayList[] = [];

			switch (index) {
				case 'quantity':
					errorCount = 0; // Quantities can always be changed
					break;
				case 'format':
					errorCount = this.applyAllFormat(value, true, errorList);
					break;
				default:
					errorCount = this.applyAllRest(value, index, true, errorList);
					break;
			}

			if (errorCount === 0) {
				this.applyAllConfirmed(index, value);
			} else {
				// There are errors, we list them to the user
				const changeTo = this.translations[index + '.' + value];

				let list = '';
				errorList.forEach((err) => {
					let label = this.pageContext.labelApplyAllWarningLine;
					label = label.replace('{0}', changeTo);
					label = label.replace('{1}', err.label);
					label = label.replace('{2}', err.quantity.toString());
					list += label;
				});
				const replacements = `${errorCount}|${this.currentItems.length}|${changeTo}|${list}`;

				window.ShowContentDialog({
					label: 'ResponsivePrintForm.ApplyAll.Warning',
					dialogId: 'applyAllWarning',
					okContentKey: 'Label.OkButtonText',
					cancelContentKey: 'Label.CancelButtonText',
					cssClass: 'rspdialog',
					replacements: replacements,
					okFunction: () => {
						this.applyAllConfirmed(index, value);
					}
				});
			}

			this.pageContext.lazyload.update(); // We have changed URLs of images -> reset the lazyloader to reload those
			this.formIsDirty = true;
		}

		private applyAllConfirmed(index: string, value: string) {
			this.formIsDirty = true;
			switch (index) {
				case 'quantity':
					this.applyAllQuantity(parseInt(value, 10));
					break;
				case 'format':
					this.applyAllFormat(value, false, null);
					break;
				default:
					this.applyAllRest(value, index, false, null);
					break;
			}
			this.initApplyAllTitle();
			this.displayTotals();
		}

		private applyAllQuantity(value: number) {
			// Change the actual items
			this.currentItems.forEach((currentItem) => {
				currentItem.products.forEach((product) => {
					product.quantity = value;
				});

				// Change the dom
				const id = `bulkItem_${currentItem.photoId}_${currentItem.photoCounter}`;

				let amount = 0;
				currentItem.products.forEach(product => amount += product.quantity);
				$('.prints-editor .item[id="' + id + '"] .info-wrapper .amount').html(this.getQuantityForOneItem(currentItem).toString());
			});
		}

		private getQuantityForOneItem(item: CartItem, predicate?: (product: CartItemProduct) => boolean): number {
			let total = 0;
			item.products.forEach(product => {
				if (!predicate || predicate(product)) total += product.quantity;
			});
			return total;
		}

		private getTotalQuantity(predicate?: (product: CartItemProduct) => boolean): number {
			let total = 0;
			this.currentItems.forEach(item => {
				total += this.getQuantityForOneItem(item, predicate);
			});
			return total;
		}

		private applyAllFormat(format: string, dryRun: boolean, errorList: DisplayList[] | null): number {
			let errorCount = 0;

			// Format is a special case, after an apply all, only 1 product should remain with the quantity set to the sum of all formats
			// We will keep the first product & remove all others
			this.currentItems.forEach((currentItem) => {
				if (dryRun)
					currentItem.applyAllFailed = false;

				const firstProduct = currentItem.products[0];
				const availableProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === firstProduct.productCode);

				const shapeKVP = eXpress.utils.findFirst(availableProduct.attributes, lv => lv.Key === 'shape');
				const shape = shapeKVP ? shapeKVP.Value : null;
				const border = firstProduct.border;
				const colorEffect = firstProduct.colorEffect;
				const paper = firstProduct.paper;

				const newProduct = this.getProductByAttributes(format, shape, border, colorEffect, paper);
				if (newProduct) {
					if (!dryRun) {
						firstProduct.productCode = newProduct.code;
						firstProduct.quantity = this.getQuantityForOneItem(currentItem);

						// Remove all others
						currentItem.products.splice(1);

						// Change the DOM
						const id = '#bulkItem_' + currentItem.photoId + '_' + currentItem.photoCounter;
						this.refreshOneItem($(id), currentItem);
					}
				} else {
					errorCount++;
					currentItem.applyAllFailed = true;
					this.applyAllFindMissingProduct('format', format, shape, border, colorEffect, paper, errorList);
				}
			});

			return errorCount;
		}

		private applyAllFindMissingProduct(whatIsChanging: string, format: string | null, shape: string | null, border: string | null, colorEffect: string | null, paper: string | null, errorList: DisplayList[] | null): void {
			let label: string | null = null;

			// The product we wanted does not exist. This can be:
			// 1) Because the format/shape isn't available
			// 2) Because the option isn't available: border, colorEffect, paper

			const product = this.getProductByAttributes(format, shape, null, null, null);
			if (whatIsChanging === 'format' || whatIsChanging === 'shape') {
				// First we check the format
				if (product === null) {
					// Only happens when changing shape or format !
					if (whatIsChanging === 'format')
						label = this.translations['shape.' + shape];
					else
						label = this.translations['format.' + format];
				} else {
					// It's not the format/shape, so an option must be missing!
					if (border) {
						const aBorder = this.getListValueArrayByCode(product.options, 'border');
						if (aBorder === null || aBorder.indexOf(border) < 0)
							label = this.translations['border.' + border];
					} else if (colorEffect) {
						const aColorEffect = this.getListValueArrayByCode(product.options, 'coloreffect');
						if (aColorEffect === null || aColorEffect.indexOf(colorEffect) < 0)
							label = this.translations['coloreffect.' + colorEffect];
					} else if (paper) {
						const aPaper = this.getListValueArrayByCode(product.options, 'paper');
						if (aPaper === null || (border && aPaper.indexOf(border) < 0))
							label = this.translations['paper.' + paper];
					}
				}
			} else {
				// We know for sure that the option - product combo is missing, report te product
				label = this.translations['format.' + format] + ' - ' + this.translations['shape.' + shape];
			}

			if (errorList !== null) {
				const existing = eXpress.utils.findFirst(errorList, (err) => err.label === label);
				if (!existing) {
					const error = new DisplayList();
					error.label = label;
					error.quantity = 1;
					errorList.push(error);
				} else
					existing.quantity++;
			}
		}

		private applyAllRest(value: string | null, category: string, dryRun: boolean, errorList: DisplayList[] | null): number {
			let errorCount = 0;

			// If value = default we should null it
			if (value === 'default')
				value = null;

			// Change the actual items
			this.currentItems.forEach((currentItem) => {
				if (dryRun)
					currentItem.applyAllFailed = false;
				currentItem.products.forEach((product) => {
					const availableProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === product.productCode);
					const formatKVP = eXpress.utils.findFirst(availableProduct.attributes, lv => lv.Key === 'format');
					const format = category === 'format' ? value : (formatKVP ? formatKVP.Value : null);
					const shapeKVP = eXpress.utils.findFirst(availableProduct.attributes, lv => lv.Key === 'shape');
					const shape = category === 'shape' ? value : (shapeKVP ? shapeKVP.Value : null);

					const border = (category === 'border' ? value : product.border);
					const colorEffect = (category === 'coloreffect' ? value : product.colorEffect);
					const paper = (category === 'paper' ? value : product.paper);

					const newProduct = this.getProductByAttributes(format, shape, border, colorEffect, paper);
					if (newProduct) {
						if (!dryRun && !currentItem.applyAllFailed) {
							// Change the item in JS
							if (category === 'shape') {
								// Shape & format -> product code changes
								product.productCode = newProduct.code;
							} else {
								// Border coloreffect & paper -> just some options are turned off or on
								switch (category) {
									case 'border':
										product.border = value;
										break;
									case 'coloreffect':
										product.colorEffect = value;
										break;
									case 'paper':
										product.paper = value;
										break;
									default:
										break;
								}
							}
						}
					} else {
						currentItem.applyAllFailed = true;
						this.applyAllFindMissingProduct(category, format, shape, border, colorEffect, paper, errorList);
					}
				});

				if (currentItem.applyAllFailed) {
					errorCount++;
				} else {
					if (!dryRun) {
						this.changeManipulationsForOneItem(currentItem, category, value);

						// Change the DOM
						const id = ('#bulkItem_' + currentItem.photoId + '_' + currentItem.photoCounter);
						this.refreshOneItem($(id), currentItem);
					}
				}

			});

			return errorCount;
		}

		private changeOptionForOneItem(item: CartItem, category, value) {
			if (value == 'default')
				value = null;

			item.products.forEach((product) => {
				switch (category) {
					case 'border':
						product.border = value;
						break;
					case 'coloreffect':
						product.colorEffect = value;
						break;
					case 'paper':
						product.paper = value;
						break;
					default:
						break;
				}
			});
		}

		private changeShapeForOneItem(item: CartItem, shape: string) {
			item.products.forEach((product) => {
				const currentProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === product.productCode);
				const newProduct = this.getProductByAttributes(currentProduct.attributesDict['format'], shape, item.products[0].border, item.products[0].colorEffect, item.products[0].paper);
				if (newProduct) {
					product.productCode = newProduct.code;
				}
			});
		}

		private changeManipulationsForOneItem(item: CartItem, category, value) {
			if (category === 'coloreffect') {
				// We need to create a manipulations effect
				switch (value) {
					case null:
					case 'default':
						item.manipulations.colorEffect = null;
						break;
					case 'printscoloreffectbw':
						item.manipulations.colorEffect = 'BlackAndWhite';
						break;
					case 'printscoloreffectsepia':
						item.manipulations.colorEffect = 'Sepia';
						break;
					default:
						break;
				}
			} else if (category === 'shape') {
				if (value === 'autosize') {
					// RESET for autosize
					item.manipulations.top = 0;
					item.manipulations.left = 0;
					item.manipulations.width = item.originalWidth;
					item.manipulations.height = item.originalHeight;

					// We need to recalculate the max crop
					const firstProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === item.products[0].productCode);
					const maxRatio = firstProduct.attributesDict['maximumratio'];
					if (maxRatio) {
						let wantedRatio = parseFloat(maxRatio);
						if (wantedRatio > 1)
							wantedRatio = 1 / wantedRatio;
						let currentRatio = (item.manipulations.width > 0 ? item.manipulations.width : item.originalWidth) / (item.manipulations.height > 0 ? item.manipulations.height : item.originalHeight);
						if (currentRatio > 1)
							currentRatio = 1 / currentRatio;
						if (currentRatio < wantedRatio) {
							const newCrop = eXpress.utils.calculateCrop(item.originalWidth, item.originalHeight, wantedRatio);
							item.manipulations.top = newCrop.Top;
							item.manipulations.left = newCrop.Left;
							item.manipulations.width = newCrop.Width;
							item.manipulations.height = newCrop.Height;
						}
					}
				} else {

					// We need to recalculate the crop !
					const wantedRatio = this.calculateWantedRatio(value);
					let currentRatio = (item.manipulations.width > 0 ? item.manipulations.width : item.originalWidth) / (item.manipulations.height > 0 ? item.manipulations.height : item.originalHeight);
					if (currentRatio > 1)
						currentRatio = 1 / currentRatio;
					// Don't exact compare ... we are fine with a minor diff
					const allowedDifference = (wantedRatio === 1) ? 0 : 0.001;
					if (Math.abs(wantedRatio - currentRatio) > allowedDifference) {
						const newCrop = eXpress.utils.calculateCrop(item.originalWidth, item.originalHeight, wantedRatio);
						item.manipulations.top = newCrop.Top;
						item.manipulations.left = newCrop.Left;
						item.manipulations.width = newCrop.Width;
						item.manipulations.height = newCrop.Height;
					}
				}
			}
		}

		private calculateWantedRatio(shape: string): number {
			const split = shape.split('x');
			let wantedRatio = parseFloat(split[1]) / parseFloat(split[0]);
			if (wantedRatio > 1)
				wantedRatio = 1 / wantedRatio;
			return wantedRatio;
		}

		private updateShoppingBasket() {
			const lowResCount = this.countLowResolutionItems();
			if (lowResCount > 0) {
				window.ShowContentDialog({
					label: 'ResponsivePrintForm.ImageQualityMessage',
					okContentKey: 'Label.OkButtonText',
					cancelContentKey: 'Label.CancelButtonText',
					cssClass: 'rspdialog',
					replacements: lowResCount,
					dialogId: 'lowQuality',
					okFunction: () => {
						this.updateShoppingBasketConfirm();
					}
				});
			} else
				this.updateShoppingBasketConfirm();
		}

		private updateShoppingBasketConfirm(): void {
			core.showLoadingDialogAsync(this.orderService.bulkEditorUpdateShoppingBasketAsync(core.context.pointOfSaleId,
				GetCookie("accid"),
				pageContext.cartId,
				this.defaultProductCode,
				this.defaultTheme,
				this.currentItems,
				this.fromcart
			).then((res) => {
				this.formIsDirty = false;
				document.location.href = res.BulkEditorUpdateShoppingBasketResult;
			}));
		}

		private countLowResolutionItems(): number {
			return this.currentItems.filter((item) => {
				return !this.checkMinResolution(item);
			}).length;
		}

		private toggleApplyAll(forceOpen = false) {
			if (forceOpen) {
				$('.top-content-container').addClass('filters-open');
			} else {
				$('.top-content-container').toggleClass('filters-open');
			}
		}

		private applyFilter($target) {
			const d = $.Deferred();

			setTimeout(() => {
				const $multiselect = $target.closest('.multiselect');
				this.applyAll($multiselect.attr('data-code') || "", $target.attr('data-code') || "");
				this.closeAllDropdowns();
				d.resolve();
			}, 150); // this is to show the loading dialog first and then the processing begins

			return d.promise();
		}

		private refreshCurrentItems() {
			const def = $.Deferred();

			setTimeout(() => {
				this.currentItems.forEach((currentItem) => {
					const id = '#bulkItem_' + currentItem.photoId + '_' + currentItem.photoCounter;
					this.refreshOneItem($(id), currentItem, 0, 0, false);
				});
				def.resolve();
			}, 150);

			return def.promise();
		}

		protected addHandlers(): void {
			super.addHandlers();

			// Apply all
			$('.filter-container').on('click', '.multiselect .selectbox-choices label', (e) => {

				e.preventDefault();
				e.stopPropagation();

				// loadingscreen while waiting
				core.showLoadingDialogAsync(this.applyFilter($(e.currentTarget)), this.currentItems.length > 100 ? 0 : 500); // if more then 100 images showloadingdialog direct else after 500ms
			});

			let timeout;
			$(window).resize((e) => {
				if (this.initialScreenWidth === window.outerWidth) return;
				this.initialScreenWidth = window.outerWidth;

				clearTimeout(timeout);
				timeout = setTimeout(() => {
					core.showLoadingDialogAsync(this.refreshCurrentItems(), this.currentItems.length > 100 ? 0 : 500);
				}, 250);
			});

			$('.edit-all').on('click', (e) => {
				this.toggleApplyAll();
			});

			$('.minimize-edit').on('click', (e) => {
				this.toggleApplyAll();
			});

			// Delete button + overlay
			$('.content-container').on('click', '.prints-editor .item .icon-delete', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				const $item = $target.closest('.item');
				$item.toggleClass('delete-enabled');
			});

			$('.content-container').on('click', '.prints-editor .item .delete-container .secondary', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				const $item = $target.closest('.item');
				$item.toggleClass('delete-enabled');
			});

			$('.content-container').on('click', '.prints-editor .item .delete-container .main', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				const $item = $target.closest('.item');
				this.deleteItem($item);
			});

			// Copy button + overlay
			$('.content-container').on('click', '.prints-editor .item .icon-copy', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				const $item = $target.closest('.item');
				$item.toggleClass('copy-enabled');
			});

			$('.content-container').on('click', '.prints-editor .item .copy-container .secondary', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				const $item = $target.closest('.item');
				$item.toggleClass('copy-enabled');
			});

			$('.content-container').on('click', '.prints-editor .item .copy-container .main', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				const $item = $target.closest('.item');
				this.copyItem($item);
				$item.toggleClass('copy-enabled');
			});

			// The total icon info
			$('.content-container').on('click', '.prints-amount .icon-info', (e) => {
				e.preventDefault();
				e.stopPropagation();

				// Toggle the clicked one
				const $tooltip = $('.prints-amount .top-info-container');
				if (!$tooltip.hasClass('open')) {
					// Close all others
					this.closeAllDropdowns();
				}

				if (this.currentItems.length > 0)
					$tooltip.toggleClass('open');
			});

			$('.content-container').on('click', '.prints-amount .delete-button', (e) => {
				e.preventDefault();
				e.stopPropagation();

				// Toggle the clicked one
				this.deleteAll();
			});

			// The info icon + overlay
			$('.content-container').on('click', '.prints-editor .item .info-wrapper .icon-info', (e) => {
				e.preventDefault();
				e.stopPropagation();

				// Toggle the clicked one
				const $target = $(e.currentTarget);
				const $parent = $target.parent();
				const $tooltip = $parent.find('.bottom-center');
				const $item = $target.closest('.item');
				if (!$tooltip.hasClass('open')) {
					// Close all others
					this.closeAllDropdowns();
					this.fillOneItemTooltip($item, $tooltip);
				}

				$tooltip.toggleClass('open');
			});

			$('.content-container').on('click', '.prints-editor .item .info-wrapper .bottom-center', (e) => {
				e.preventDefault();
				e.stopPropagation();
			});

			$('.content-container').on('click', '.prints-editor .item .info-wrapper .tooltip .close', (e) => {
				const $target = $(e.currentTarget);
				const $tooltip = $target.closest('.bottom-center');
				$tooltip.toggleClass('open');
			});

			// Add to shopping basket
			$('.technical-to-basket').on('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.updateShoppingBasket();
			}).show().removeClass("u-hide");

			// Adding photos
			$('.content-container').on('click', '.add-photo', async () => {
				await this.openAddDialogAsync();
			});

			// The edit dialog and all buttons concerning the edit
			$('.content-container').on('click', '.prints-editor .item.print:not(.add-photo)', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				const $item = $target.closest('.item');

				this.openEditDialog($item);
			});

			$('body').on('click', '#ActionDialog .preview-container .action.info, #ActionDialog .panel-container.photo-info-panel', (e) => {
				$('.dialog-body').toggleClass('panel-open');
			});

			// Save & cancel changes
			$('body').on('click', '#ActionDialog .exit-button, #ActionDialog .dialog-body .buttons-container button', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);

				const saveChanges = $target.hasClass('button-check');

				this.closeEditDialog(saveChanges);
			});

			// The format tab actual logic
			$('body').on('click', '#ActionDialog .tools-container .tool-body.format .counter', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				const $format = $target.closest('.format-item');
				const format = $format.attr('data-code')!;

				const amount = $target.hasClass('counter-minus') ? -1 : 1;

				this.updateOneItemQuantityPlusMin(this.editItem, format, amount);
			});

			// Prevent input other than numbers
			$('body').on("keypress", '#ActionDialog .tools-container .tool-body.format .quantity-input', function (event) {
				window.PreventInvalidInput($(this), /^[0-9]\d*$/, event);
			});

			// Prevent copy - paste of text, if not a valid number, revert to old value from cartItemProduct
			$('body').on('keyup', '#ActionDialog .tools-container .tool-body.format .quantity-input', (e) => {
				const $target = $(e.currentTarget);
				const $format = $target.closest('.format-item');
				const format = $format.attr('data-code')!;
				const newValue = +($target.val() || 0);

				if (this.validateQuantity(newValue))
					this.updateOneItemQuantityFixed(this.editItem, format, newValue);
				else {
					const filtered = this.editItem.products.filter(e => e.productCode.indexOf(format) >= 0);
					if (!$.isEmptyObject(filtered))
						$target.val(filtered[0].quantity);
					else
						$target.val(0);
				}
			});

			$('body').on('keyup', '#ActionDialog .tools-container .tool-body.format .quantity-input', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				const $format = $target.closest('.format-item');
				const format = $format.attr('data-code') || '';

				const amount = +($target.val() || 0);
				this.updateOneItemQuantityFixed(this.editItem, format, amount);

			});

			// The shape tab actual logic
			$('body').on('click', '#ActionDialog .tools-container .tool-body.shape .option-list span.option:not(.active):not(.disabled)', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				const shape = $target.attr('data-code') || '';

				this.updateOneItemShape(this.editItem, shape);
			});

			// The paper actual logic
			$('body').on('click', '#ActionDialog .tools-container .tool-body.finish div.paper .option-list span.option:not(.active):not(.disabled)', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				const paper = $target.attr('data-code') || '';

				this.updateOneItemOption(this.editItem, 'paper', paper);
				// Set to active
				$('#ActionDialog .tools-container .tool-body.finish div.paper .option-list span').removeClass('active').filter('[data-code="' + paper + '"]').addClass('active');
			});

			// The border actual logic
			$('body').on('click', '#ActionDialog .tools-container .tool-body.finish div.border .option-list span.option:not(.active):not(.disabled)', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				const border = $target.attr('data-code') || '';

				this.updateOneItemOption(this.editItem, 'border', border);
				// Set to active
				$('#ActionDialog .tools-container .tool-body.finish div.border .option-list span').removeClass('active').filter('[data-code="' + border + '"]').addClass('active');
			});

			$('body').on('click', '#ActionDialog .tools-container .tool-body .option-item h4', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				$target.closest(".option-item").addClass("active");
			});

			$('body').on('click', '#ActionDialog .tools-container .tool-body .action-close', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				$target.closest(".option-item").removeClass("active");
			});

			// The coloreffect actual logic
			$('body').on('click', '#ActionDialog .tools-container .tool-body.effect .option-list div:not(.active):not(.disabled)', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				const coloreffect = $target.attr('data-code') || '';

				this.updateOneItemOption(this.editItem, 'coloreffect', coloreffect);
				// Set to active
				$('#ActionDialog .tools-container .tool-body.effect .option-list div').removeClass('active').filter('[data-code="' + coloreffect + '"]').addClass('active');
			});

			$('body').on('click', '#ActionDialog .tools-container .toolbuttons button:not(.active)', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);
				this.editDialogSwitchTab($target.attr('class') || '');
			});

			// The edit tab
			$('body').on('click', '#ActionDialog .tools-container .tool-body.edit .rotate-90', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);

				this.updateOneItemRotate90($target.hasClass('rotate-right') ? 90 : -90);
			});

			$('body').on('click', '#ActionDialog .tools-container .tool-body.edit .option-list span:not(.active)', (e) => {
				e.preventDefault();
				e.stopPropagation();

				const $target = $(e.currentTarget);

				$('#ActionDialog .tools-container .tool-body.edit .option-list span').removeClass('active');
				$target.addClass('active');

				if ($target.hasClass('crop')) {
					this.initEditDialogEdit(this.editItem);
				} else if ($target.hasClass('rotate')) {
					this.resetCroppingImage(this.editItem);
					this.initEditDialogRotate90(this.editItem);
				} else {
					this.resetCroppingImage(this.editItem);
				}
			});

			$('body').on('click', '#ActionDialog .tools-container .tool-body.edit .div-rotate .button-container .action-close', (e) => {
				e.preventDefault();
				e.stopPropagation();

				$('#ActionDialog .tools-container .tool-body.edit .div-rotate').removeClass('active');
			});

			// sorting
			this.$sorting.on("click", "label", (e) => this.sortEvent(e));
		}

		private sortEvent(event: JQuery.ClickEvent) {
			const $label = $(event.currentTarget);
			if ($label.hasClass("checked"))
				return;

			const methodChunks = ($label.attr("data-sp-filter-tag") || '').split('-');
			const sortOrder = SortOrder[methodChunks[1]];
			const sortBy = PrintSortBy[methodChunks[0]];

			this.sortAndDisplayItems(sortBy, sortOrder);
		}

		private openEditDialog($domItem: JQuery) {
			this.closeAllDropdowns();
			window.ShowActionDialog({
				action: 'BulkEditorEdit',
				cssClass: "rspdialog dialog-fullscreen dialog-photo-edit dialog-no-header dialog-no-footer " + utils.makeCssClass(this.productCategoryGroupCode),
				openFunction: (e) => {
					const photoId = $domItem.attr('fileid') || '';
					const photoCounter = +($domItem.attr('photocounter') || 0);
					const item = this.getItemByPhotoIdAndCounter(photoId, photoCounter);

					this.initEditDialog(item);
				}
			});
		}

		private initEditDialog(item: CartItem) {
			this.croppingIsActive = false;

			// Store the current edit item for future actions
			this.editItem = utils.clone(item);

			// Set the URL of the image
			const $previewContainer = $('.preview-container');
			const $img = $previewContainer.find('.img-wrapper img');
			$img.attr('src', bulkeditor.fillOneItemUrl(item, this.context.ecomApiUrl, this.getWhiteBorderType(item), false, false));

			// Set the data of the image
			$('.photo-title-container').html(item.originalFileName);
			const $panel = $('.photo-info-panel');
			$panel.find('.storage-data').hide();
			$panel.find('.filename').html(item.originalFileName);
			if (item.fileSize) {
				$panel.find('.filesize').html((Math.round((item.fileSize / 1024) * 100) / 100).toFixed(2) + "KB");
				$panel.find('.filesize').parent().removeClass('u-hide');
			} else {
				$panel.find('.filesize').parent().addClass('u-hide');
			}

			$panel.find('.resolution').html(item.originalWidth.toString() + "x" + item.originalHeight.toString());
			$panel.find('.datetaken').html(item.datePictureTaken.toLocaleDateString() + "-" + item.datePictureTaken.toLocaleTimeString());

			if (!this.checkMinResolution(item)) {
				$previewContainer.find('.warning').show();
			}

			const $buttons = $('.tools-container .toolbuttons');
			// Disable some tabs based on availability
			if (this.availableShapes.length <= 1)
				$buttons.find('.shape').hide();
			if (this.availablePapers.length <= 1 && this.availableBorders.length <= 1)
				$buttons.find('.finish').hide();
			if (this.availableColorEffects.length <= 1)
				$buttons.find('.effect').hide();


			// By default, no tab is selected, on mobile this is OK, but on desktop we want the format tab
			$buttons.find('button:visible').first().addClass('active');
			if ($('.tools-container .toolbuttons .gallery').is(":visible")) {
				this.editDialogSetActiveClass('gallery');
			} else {
				this.initEditDialogFormat(this.editItem);
				this.editDialogSetActiveClass('format');
				$('.tools-container .tool-body.format').show();
			}
		}

		private initEditDialogFormat(item: CartItem) {
			const $table = $('.tools-container .tool-body.format table');
			const $container = $table.find('tbody').detach();
			const $template = $container.find('.format-item-template');
			$container.find('.format-item').remove(); // Removes all existing ones

			this.availableFormats.forEach((format) => {
				const $new = $template.clone().removeClass('format-item-template').addClass('format-item').show();

				$new.find('.size').html(this.translations['format.' + format]);

				const quantity = this.getQuantityForOneItem(item, (product) => {
					const availableProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === product.productCode);
					return (availableProduct.attributesDict['format'] === format);
				});
				$new.find('.quantity-input').val(quantity);

				$new.attr('data-code', format);

				// Mark it as disabled?
				const firstProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === item.products[0].productCode);
				const newProduct = this.getProductByAttributes(format, firstProduct.attributesDict['shape'], item.products[0].border, item.products[0].colorEffect, item.products[0].paper);
				if (!newProduct)
					$new.addClass("disabled");

				$container.append($new);
			});

			$table.append($container);
		}

		private initEditDialogShape(item: CartItem) {
			const $div = $('.tools-container .tool-body.shape');
			const $container = $div.find('.option-list').detach();
			const $template = $container.find('.shape-item-template');
			$container.find('.shape-item').remove(); // Removes all existing ones

			const firstProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === item.products[0].productCode);
			const activeShape = firstProduct.attributesDict['shape'];
			this.availableShapes.forEach((shape) => {
				const $new = $template.clone().removeClass('shape-item-template').addClass('shape-item').css('display', ''); // Why not show? it will add display: inline and it should be cleared

				$new.html(this.translations['shape.' + shape]);

				// Mark the active one as active
				if (shape === activeShape)
					$new.addClass('active');
				$new.addClass(utils.makeCssClass('shape-' + shape));
				$new.attr('data-code', shape);

				// Mark it as disabled?
				// All products alternatives should be there
				let disabled = false;
				item.products.forEach((product) => {
					const availableProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === product.productCode);
					const newProduct = this.getProductByAttributes(availableProduct.attributesDict['format'], shape, item.products[0].border, item.products[0].colorEffect, item.products[0].paper);
					if (!newProduct)
						disabled = true;
				});
				if (disabled)
					$new.addClass("disabled");

				$container.append($new);
			});

			$div.append($container);
		}

		private initEditDialogPaperBorderOrColorEffect(item: CartItem, $html: JQuery, category: string, active: string, list: string[]) {
			if (list.length === 1) {
				$html.closest('.option-item').remove();
				return;
			}

			const $container = $html.find('.option-list').detach();
			const $template = $container.find('.' + category + '-item-template');
			const $close = $container.find('.action-close');
			$container.find('.' + category + '-item').remove(); // Removes all existing ones

			list.forEach((x) => {
				const $new = $template.clone().removeClass(category + '-item-template').addClass(category + '-item').css('display', ''); // Why not show? it will add display: inline and it should be cleared

				if (category === 'coloreffect')
					$new.append(this.translations[category + '.' + x]);
				else
					$new.html(this.translations[category + '.' + x]);

				// Mark the active one as active
				if (x === active)
					$new.addClass('active');
				$new.addClass(utils.makeCssClass(category + '-' + x));
				$new.attr('data-code', x);

				// Mark it as disabled?
				// All products alternatives should be there (default is always allowed)
				if (x !== 'default') {
					let disabled = false;
					item.products.forEach((product) => {
						const availableProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === product.productCode);
						const border = category === 'border' ? x : item.products[0].border;
						const coloreffect = category === 'coloreffect' ? x : item.products[0].colorEffect;
						const paper = category === 'paper' ? x : item.products[0].paper;

						const newProduct = this.getProductByAttributes(availableProduct.attributesDict['format'], availableProduct.attributesDict['shape'], border, coloreffect, paper);
						if (!newProduct)
							disabled = true;
					});
					if (disabled)
						$new.addClass("disabled");
				}

				// Sometimes, there is a close button, append behind it !
				if ($close.length > 0)
					$close.before($new);
				else
					$container.append($new);
			});

			$html.append($container);
		}

		private initEditDialogPaper(item: CartItem) {
			const $div = $('.tools-container .tool-body.finish .paper');
			const active = item.products[0].paper ? item.products[0].paper : 'default';
			this.initEditDialogPaperBorderOrColorEffect(item, $div, 'paper', active, this.availablePapers);
		}

		private initEditDialogBorder(item: CartItem) {
			const $div = $('.tools-container .tool-body.finish .border');
			const active = item.products[0].border ? item.products[0].border : 'default';
			this.initEditDialogPaperBorderOrColorEffect(item, $div, 'border', active, this.availableBorders);
		}

		private initEditDialogColorEffect(item: CartItem) {
			this.cropperDestroy();
			const $div = $('.tools-container .tool-body.effect');
			const active = item.products[0].colorEffect ? item.products[0].colorEffect : 'default';
			this.initEditDialogPaperBorderOrColorEffect(item, $div, 'coloreffect', active, this.availableColorEffects);
		}

		private initEditDialogEdit(item: CartItem) {
			// Set the URL of the image (no cropping & no white borders !)
			const $img = $('.preview-container .img-wrapper img');
			$img.on("load", (e) => {
				this.initEditDialogEditContinue();
			});

			$img.attr('src', bulkeditor.fillOneItemUrl(item, this.context.ecomApiUrl, this.getWhiteBorderType(item), true, false));
			this.croppingIsActive = true;
		}

		private initEditDialogEditContinue() {
			/* tslint:disable:max-line-length */
			const style = $('<style id="toRemove">.dialog-content.dialog-photo-edit .preview-container .img-wrapper .jcrop-holder img { max-height: none; max-width: none; transform: none; } .jcrop-holder{direction:ltr;text-align:left;display:inline-block}.jcrop-vline,.jcrop-hline{background:#fff url("Jcrop.gif");font-size:0;position:absolute}.jcrop-vline{height:100%;width:1px!important}.jcrop-vline.right{right:0}.jcrop-hline{height:1px!important;width:100%}.jcrop-hline.bottom{bottom:0}.jcrop-tracker{height:100%;width:100%;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none}.jcrop-handle{background-color:#333;border:1px #eee solid;width:7px;height:7px;font-size:1px}.jcrop-handle.ord-n{left:50%;margin-left:-4px;margin-top:-4px;top:0}.jcrop-handle.ord-s{bottom:0;left:50%;margin-bottom:-4px;margin-left:-4px}.jcrop-handle.ord-e{margin-right:-4px;margin-top:-4px;right:0;top:50%}.jcrop-handle.ord-w{left:0;margin-left:-4px;margin-top:-4px;top:50%}.jcrop-handle.ord-nw{left:0;margin-left:-4px;margin-top:-4px;top:0}.jcrop-handle.ord-ne{margin-right:-4px;margin-top:-4px;right:0;top:0}.jcrop-handle.ord-se{bottom:0;margin-bottom:-4px;margin-right:-4px;right:0}.jcrop-handle.ord-sw{bottom:0;left:0;margin-bottom:-4px;margin-left:-4px}.jcrop-dragbar.ord-n,.jcrop-dragbar.ord-s{height:7px;width:100%}.jcrop-dragbar.ord-e,.jcrop-dragbar.ord-w{height:100%;width:7px}.jcrop-dragbar.ord-n{margin-top:-4px}.jcrop-dragbar.ord-s{bottom:0;margin-bottom:-4px}.jcrop-dragbar.ord-e{margin-right:-4px;right:0}.jcrop-dragbar.ord-w{margin-left:-4px}.jcrop-light .jcrop-vline,.jcrop-light .jcrop-hline{background:#fff;filter:alpha(opacity=70)!important;opacity:.7!important}.jcrop-light .jcrop-handle{-moz-border-radius:3px;-webkit-border-radius:3px;background-color:#000;border-color:#fff;border-radius:3px}.jcrop-dark .jcrop-vline,.jcrop-dark .jcrop-hline{background:#000;filter:alpha(opacity=70)!important;opacity:.7!important}.jcrop-dark .jcrop-handle{-moz-border-radius:3px;-webkit-border-radius:3px;background-color:#fff;border-color:#000;border-radius:3px}.solid-line .jcrop-vline,.solid-line .jcrop-hline{background:#fff}.jcrop-holder img,img.jcrop-preview{max-width:none}</style>');
			/* tslint:disable:max-line-length */
			$('html > head').append(style);

			const $img = $('.preview-container .img-wrapper img');
			this.cropperInit(this.editItem, $img);

			// Set the button to active
			$('.tools-container .tool-body.edit .option').removeClass('active').filter('.crop').addClass('active');

			$('#ActionDialog .tools-container .tool-body.edit .div-crop').addClass('active');
			$('#ActionDialog .tools-container .tool-body.edit .div-rotate').removeClass('active');
			$('#ActionDialog .tools-container .tool-body.edit .div-red-eyes').removeClass('active');
		}

		private initEditDialogRotate90(item: CartItem) {
			$('#ActionDialog .tools-container .tool-body.edit .div-crop').removeClass('active');
			$('#ActionDialog .tools-container .tool-body.edit .div-rotate').addClass('active');
			$('#ActionDialog .tools-container .tool-body.edit .div-red-eyes').removeClass('active');
		}

		private cropperRatio(item: CartItem, $img: JQuery): number {
			const imageWidth = $img.width()!;
			let originalWidth = item.originalWidth;
			if (item.manipulations.rotate90 === 90 || item.manipulations.rotate90 === 270)
				originalWidth = item.originalHeight;

			return originalWidth / imageWidth;
		}

		private cropperSelect(item: CartItem, ratio: number): number[] {
			let top = 0;
			let left = 0;
			let width = item.originalWidth;
			let height = item.originalHeight;
			if (item.manipulations != null) {
				if (item.manipulations.top !== 0 || item.manipulations.left !== 0 || item.manipulations.width !== 0 || item.manipulations.height !== 0) {
					top = item.manipulations.top;
					left = item.manipulations.left;
					width = item.manipulations.width;
					height = item.manipulations.height;
				}
			}

			let originalTopLeftX, originalTopLeftY, originalBottomRightX, originalBottomRightY;
			if (item.manipulations == null || item.manipulations.rotate90 === 0) {
				originalTopLeftX = left;
				originalTopLeftY = top;
				originalBottomRightX = width + left;
				originalBottomRightY = height + top;
			} else if (item.manipulations.rotate90 === 90) {
				originalTopLeftX = item.originalHeight - height - top;
				originalTopLeftY = left;
				originalBottomRightX = item.originalHeight - top;
				originalBottomRightY = width + left;
			} else if (item.manipulations.rotate90 === 180) {
				originalTopLeftX = item.originalWidth - left;
				originalTopLeftY = item.originalHeight - height - top;
				originalBottomRightX = item.originalWidth - width - left;
				originalBottomRightY = item.originalHeight - top;
			} else if (item.manipulations.rotate90 === 270) {
				originalTopLeftX = top;
				originalTopLeftY = item.originalWidth - width - left;
				originalBottomRightX = height + top;
				originalBottomRightY = item.originalWidth - left;
			}

			return [originalTopLeftX / ratio, originalTopLeftY / ratio, originalBottomRightX / ratio, originalBottomRightY / ratio];
		}

		private cropperInit(item: CartItem, $img: JQuery) {

			const ratio = this.cropperRatio(item, $img);

			const firstProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === item.products[0].productCode);
			let aspectRatio = 0;
			let aspectRatioIsLimit = false;
			if (firstProduct.attributesDict['shape'] !== 'autosize') {
				aspectRatio = this.calculateWantedRatio(firstProduct.attributesDict['shape']);
				if (mediastore.itemGetOrientation(item) === 'landscape')
					aspectRatio = 1 / aspectRatio;
			} else {
				if (firstProduct.attributesDict['maximumratio'])
					aspectRatio = parseFloat(firstProduct.attributesDict['maximumratio']);
				aspectRatioIsLimit = true;
			}
			const initialCrop = this.cropperSelect(item, ratio);
			const options = {
				onSelect: (data) => {
					this.cropperSet(data);
				},
				minSize: [20, 20],
				setSelect: initialCrop,
				aspectRatio: aspectRatio,
				aspectRatioIsLimit: aspectRatioIsLimit,
				bgColor: "white",
				bgOpacity: 1
			};


			$img.Jcrop(options);
		}

		private cropperSet(cropResult: any) {
			// Click outside the crop area
			if (cropResult.w === 0 && cropResult.h === 0)
				return;

			const $img = $('#editImage');

			const ratio = this.cropperRatio(this.editItem, $img);

			if (this.editItem.manipulations == null)
				this.editItem.manipulations = new mediastore.Manipulations();


			if (this.editItem.manipulations.rotate90 === 0) {
				this.editItem.manipulations.top = Math.round(cropResult.y * ratio);
				this.editItem.manipulations.left = Math.round(cropResult.x * ratio);
				this.editItem.manipulations.width = Math.round(cropResult.w * ratio);
				this.editItem.manipulations.height = Math.round(cropResult.h * ratio);
			} else if (this.editItem.manipulations.rotate90 === 90) {
				this.editItem.manipulations.top = this.editItem.originalHeight - Math.round((cropResult.x + cropResult.w) * ratio);
				this.editItem.manipulations.left = Math.round(cropResult.y * ratio);
				this.editItem.manipulations.width = Math.round(cropResult.h * ratio);
				this.editItem.manipulations.height = Math.round(cropResult.w * ratio);
			} else if (this.editItem.manipulations.rotate90 === 180) {
				this.editItem.manipulations.top = this.editItem.originalHeight - Math.round((cropResult.y + cropResult.h) * ratio);
				this.editItem.manipulations.left = this.editItem.originalWidth - Math.round((cropResult.x + cropResult.w) * ratio);
				this.editItem.manipulations.width = Math.round(cropResult.w * ratio);
				this.editItem.manipulations.height = Math.round(cropResult.h * ratio);
			} else if (this.editItem.manipulations.rotate90 === 270) {
				this.editItem.manipulations.top = Math.round(cropResult.x * ratio);
				this.editItem.manipulations.left = this.editItem.originalWidth - Math.round((cropResult.y + cropResult.h) * ratio);
				this.editItem.manipulations.width = Math.round(cropResult.h * ratio);
				this.editItem.manipulations.height = Math.round(cropResult.w * ratio);
			}

			const $previewContainer = $('.preview-container');
			$previewContainer.find('.warning').toggle(!this.checkMinResolution(this.editItem));
		}

		private cropperDestroy() {
			const $jcropDiv = $(".jcrop-holder");
			const $img = $('#editImage');

			$img.unbind('load');
			if ($jcropDiv.length > 0) {
				$jcropDiv.remove();
				$img.css('display', '');
				$img.css('visibility', '');
				$img.css('width', '');
				$img.css('height', '');
				$img.removeData('Jcrop');
			}
		}

		private validateQuantity(quantity: number): boolean {
			if (isNaN(quantity))
				return false;
			if (quantity < 0 || quantity > 999)
				return false;

			return true;
		}

		private updateOneItemQuantityPlusMin(item: CartItem, format: string, amount: number) {
			if (amount < 0 && this.getQuantityForOneItem(item) + amount <= 0) {
				return;
			}

			this.updateOneItemQuantity(item, format, amount, true);
		}

		private updateOneItemQuantityFixed(item: CartItem, format: string, amount: number) {
			this.updateOneItemQuantity(item, format, amount, false);
		}

		private updateOneItemQuantity(item: CartItem, format: string, amount: number, add: boolean) {
			this.formIsDirty = true;

			let addNewProduct = true;
			let counter = -1;
			let removeProduct = -1;
			item.products.forEach((product) => {
				counter++;
				const availableProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === product.productCode);
				if (availableProduct.attributesDict['format'] === format) {
					if (add) {
						if (product.quantity + amount <= 999)
							product.quantity += amount;
					} else
						product.quantity = amount;

					if (product.quantity <= 0) {
						// We need to remove the item but at least 1 should remain !!!
						if (this.getQuantityForOneItem(item) > 0)
							removeProduct = counter;
						else
							product.quantity = 1;
					}
					addNewProduct = false;

					// Update the DOM of the edit dialog
					$('.tools-container .format .format-item[data-code="' + format + '"] .quantity-input').val(product.quantity);

					const $previewContainer = $('.preview-container');
					$previewContainer.find('.warning').toggle(!this.checkMinResolution(item));
				}
			});

			if (removeProduct > -1) {
				item.products.splice(removeProduct, 1);
			}

			if (addNewProduct && amount > 0) {
				const firstProduct = eXpress.utils.findFirstOrError(this.availableProducts, p => p.code === item.products[0].productCode);

				const newProduct = this.getProductByAttributes(format, firstProduct.attributesDict['shape'], item.products[0].border, item.products[0].colorEffect, item.products[0].paper);
				if (newProduct != null) {
					const product = new CartItemProduct(newProduct.code, amount);
					product.paper = item.products[0].paper;
					product.border = item.products[0].border;
					product.colorEffect = item.products[0].colorEffect;
					item.products.push(product);

					// Update the DOM of the edit dialog
					$('.tools-container .format .format-item[data-code="' + format + '"] .quantity-input').val(product.quantity);
				}
			}

			const $previewContainer = $('.preview-container');
			$previewContainer.find('.warning').toggle(!this.checkMinResolution(item));
		}

		private updateOneItemShape(item: CartItem, shape: string) {
			this.formIsDirty = true;

			this.changeShapeForOneItem(item, shape);
			this.changeManipulationsForOneItem(item, 'shape', shape);

			// Set to active
			$('#ActionDialog .tools-container .tool-body.shape .option-list span').removeClass('active').filter('[data-code="' + shape + '"]').addClass('active');

			const $previewContainer = $('.preview-container');
			$previewContainer.find('.warning').toggle(!this.checkMinResolution(item));

			// Set the URL of the image
			const $img = $previewContainer.find('.img-wrapper img');
			$img.attr('src', bulkeditor.fillOneItemUrl(item, this.context.ecomApiUrl, this.getWhiteBorderType(item), false, false));
		}

		private updateOneItemOption(item: CartItem, category: string, value: string) {
			this.formIsDirty = true;

			this.changeOptionForOneItem(item, category, value);
			if (category === 'coloreffect') {
				this.changeManipulationsForOneItem(item, 'coloreffect', value);
			}
			if (category === 'coloreffect' || category === 'border') {
				// Set the URL of the image
				const $previewContainer = $('.preview-container');
				const $img = $previewContainer.find('.img-wrapper img');
				$img.attr('src', bulkeditor.fillOneItemUrl(item, this.context.ecomApiUrl, this.getWhiteBorderType(item), false, false));
			}
		}

		private closeEditDialog(saveChanges: boolean) {
			if (saveChanges) {
				// Replace the existing item with the one coming from the edit dialog
				const existing = this.getItemByPhotoIdAndCounter(this.editItem.photoId, this.editItem.photoCounter);
				const index = this.currentItems.indexOf(existing);
				if (index !== -1) {
					this.currentItems[index] = this.editItem;
				}

				// Refresh the last edited item DOM
				const id = ('#bulkItem_' + this.editItem.photoId + '_' + this.editItem.photoCounter);
				this.refreshOneItem($(id), this.editItem);
				this.pageContext.lazyload.update();

				// Refresh the totals on the overview
				this.displayTotals();
			}

			// Refresh the apply all titles
			this.initApplyAllTitle();

			window.CloseResponsiveDialog('ActionDialog');
		}

		private editDialogSetActiveClass(tab: string) {
			const $body = $('.dialog-body');
			$body.removeClass('gallery-active format-active shape-active finish-active effect-active edit-active');
			$body.addClass(tab + '-active');
		}

		private editDialogSwitchTab(tab: string) {
			// close other tabs
			$('.tools-container .toolbuttons button').removeClass('active');
			$('.tools-container .tool-body').hide();

			this.editDialogSetActiveClass(tab);

			// init the selected one
			switch (tab) {
				case 'format':
					this.resetCroppingImage(this.editItem);
					this.initEditDialogFormat(this.editItem);
					break;
				case 'shape':
					this.resetCroppingImage(this.editItem);
					this.initEditDialogShape(this.editItem);
					break;
				case 'finish':
					this.resetCroppingImage(this.editItem);
					this.initEditDialogPaper(this.editItem);
					this.initEditDialogBorder(this.editItem);
					break;
				case 'effect':
					this.resetCroppingImage(this.editItem);
					this.initEditDialogColorEffect(this.editItem);
					break;
				case 'edit':
					this.initEditDialogEdit(this.editItem);
					break;
				default:
					this.resetCroppingImage(this.editItem);
					break;
			}

			// open the selected one
			$('.tools-container .toolbuttons button.' + tab).addClass('active');
			$('.tools-container .tool-body.' + tab).show();

		}

		private resetCroppingImage(item: CartItem) {
			if (this.croppingIsActive) {
				// Set the URL of the image (no cropping & no white borders !)
				const $img = $('.preview-container .img-wrapper img');
				$img.attr('src', bulkeditor.fillOneItemUrl(item, this.context.ecomApiUrl, this.getWhiteBorderType(item), false, false));
				this.croppingIsActive = false;

				this.cropperDestroy();
			}
		}

		private updateOneItemRotate90(angle: number) {
			this.formIsDirty = true;

			if (this.editItem.manipulations == null)
				this.editItem.manipulations = new mediastore.Manipulations();

			let rotate = this.editItem.manipulations.rotate90;
			rotate += angle;
			if (rotate >= 360) {
				rotate = rotate % 360;
			}
			if (rotate < 0) {
				rotate += 360;
			}
			this.editItem.manipulations.rotate90 = rotate;

			const $previewContainer = $('.preview-container');

			// Set the URL of the image
			const $img = $previewContainer.find('.img-wrapper img');
			$img.attr('src', bulkeditor.fillOneItemUrl(this.editItem, this.context.ecomApiUrl, this.getWhiteBorderType(this.editItem), false, false));
		}

		private initAvailableLists(): void {
			this.availableFormats = [];
			this.availableShapes = [];
			this.availableBorders = [];
			this.availablePapers = [];
			this.availableColorEffects = [];

			// Warning: Options need a default
			this.availableBorders.push('default');
			this.availablePapers.push('default');
			this.availableColorEffects.push('default');

			this.availableProducts.forEach((product) => {
				product.attributes.forEach((attribute) => {
					const value = attribute.Value.toLowerCase();
					if (attribute.Key === 'format')
						if (this.availableFormats.indexOf(value) < 0)
							this.availableFormats.push(value);
					if (attribute.Key === 'shape')
						if (this.availableShapes.indexOf(value) < 0) {
							this.availableShapes.push(value);
						}
				});

				product.options.forEach((options) => {
					const key = options.Key.toLowerCase();
					const value = options.Value;
					if (key.substr(0, 6) === 'border') {
						for (let i = 0; i < value.length; i++) {
							if (this.availableBorders.indexOf(value[i].toLowerCase()) < 0)
								this.availableBorders.push(value[i].toLowerCase());
						}
					} else if (key.substr(0, 5) === 'paper') {
						value.forEach(oneValue => {
							if (this.availablePapers.indexOf(oneValue.toLowerCase()) < 0)
								this.availablePapers.push(oneValue.toLowerCase());
						});
					} else if (key.substr(0, 11) === 'coloreffect') {
						value.forEach(oneValue => {
							if (this.availableColorEffects.indexOf(oneValue.toLowerCase()) < 0)
								this.availableColorEffects.push(oneValue.toLowerCase());
						});
					}
				});
			});

			// sort available shapes array like bulksquenceshapes
			const sorting = this.bulkSequenceShapes;
			const knownItems = [] as string[];
			let sorted = [] as string[];

			// Remove duplicates
			let unknownItems = this.availableShapes;

			sorting.forEach(key => {
				unknownItems = unknownItems.filter(item => {
					if (item === key) {
						knownItems.push(item);
						return false;
					}
					return true;
				});
			});
			// past the 2 arrays together
			sorted = knownItems.concat(unknownItems);
			// replace the array with the sorted one
			this.availableShapes = sorted;
			// Sorting ?
			this.availableFormats.sort((f, g) => {
				return (parseInt(f, 10) - parseInt(g, 10));
			});
		}

		private setSelectedSortingInUI(sortBy: PrintSortBy, sortOrder: SortOrder) {
			const method = PrintSortBy[sortBy] + "-" + SortOrder[sortOrder];
			this.$sorting.find("label").removeClass("checked");
			this.$sorting.find("label[data-sp-filter-tag=" + method + "]").addClass("checked");
		}

		private sortAndDisplayItems(sortBy: PrintSortBy, sortOrder: SortOrder) {
			this.setSelectedSortingInUI(sortBy, sortOrder);
			this.sortItems(sortBy, sortOrder);
			this.clearItems();
			this.displayItems();
		}

		private clearItems() {
			$('.prints-editor').find(".print.item").not('.add-photo').remove();
		}

		private sortItems(sortBy: PrintSortBy, sortOrder: SortOrder) {
			switch (sortBy) {
				case PrintSortBy.DateTaken:
					this.currentItems = this.currentItems.sort((a, b) => this.compareByDateTaken(a, b));
					break;
				case PrintSortBy.Name:
					this.currentItems = this.currentItems.sort((a, b) => this.compareByName(a, b));
					break;
				case PrintSortBy.DateAdded:
					this.currentItems = this.currentItems.sort((a, b) => this.compareByDateAdded(a, b));
					break;
				default:
					break;
			}

			if (sortOrder === SortOrder.Descending)
				this.currentItems = this.currentItems.reverse();
		}

		private registerNavigateAwayQuestion(): void {
			$(window).on('beforeunload', () => this.onBeforeUnload());

			$(document).on("click.link", "a", (e: JQueryEventObject) => {
				if (!this.formIsDirty)
					return true;

				const $a = $(e.currentTarget);
				const href = $a.attr("href")!;
				const rel = $a.attr("rel");
				const target = $a.attr("target");

				if (rel !== 'no' && target !== "_blank" && href !== "#" && href !== undefined) {
					this.navigateAwayQuestion(href);
					return false;
				} else {
					return true;
				}
			});
		}

		private onBeforeUnload = () => {
			if (!this.formIsDirty)
				return;

			return this.pageContext.labelUnload;
		};

		private navigateAwayQuestion(url: string): void {
			let label = 'ProductEditor.Prints.NavigateAway.Message.AddToCart';
			if (this.hadItemsInBasket)
				label = 'ProductEditor.Prints.NavigateAway.Message.UpdateCart';

			window.ShowContentDialog({
				'label': label,
				'dialogId': 'navigateAway',
				'okContentKey': 'Label.ProductEditor.Prints.NavigateAway.Save',
				'cancelContentKey': 'Label.ProductEditor.Prints.NavigateAway.Discard',
				'title': "Label.ProductEditor.Prints.NavigateAway.Title",
				'cssClass': 'notification',
				'okFunction': () => {
					this.updateShoppingBasket();
				},
				'cancelFunction': () => {
					this.formIsDirty = false;
					window.location.href = url;
				}
			});
		}

		// comparers

		private compareByName(itemA: CartItem, itemB: CartItem) {
			if (itemA.originalFileName.toLowerCase() === itemB.originalFileName.toLowerCase())
				return 0;

			if (itemA.originalFileName.toLowerCase() < itemB.originalFileName.toLowerCase())
				return -1;

			return 1;
		}

		private compareByDateTaken(itemA: CartItem, itemB: CartItem) {
			if (itemA.datePictureTaken === itemB.datePictureTaken)
				return 0;

			if (itemA.datePictureTaken < itemB.datePictureTaken)
				return -1;

			return 1;
		}

		private compareByDateAdded(itemA: CartItem, itemB: CartItem) {
			if (itemA.createdForced === itemB.createdForced)
				return 0;

			if (itemA.createdForced <
				itemB.createdForced)
				return -1;

			return 1;
		}
	}

	const services = new eXpress.services.Services(core.context);
	const deps = {
		orderService: new eXpress.services.OrderService(core.context),
		contentService: new eXpress.services.ContentService(core.context),
		accountService: new eXpress.services.AccountService(core.context)
	};

	const app = new BulkEditorApp(deps, services, core.context, pageContext);
	app.start();

	export function getUsedPhotoIds(): string[] {
		return app.getUsedPhotoIds();
	}

	export function getUsedPhotoNames(): string[] {
		return app.getUsedPhotoNames();
	}
}
